/**
 * 获取最近7天的日期
 * @returns 
 */
export function getLastSevenDates() {
    const dates = [];
    const currentDate = new Date();
    for (let i = 6; i >= 0; i--) {
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        dates.push(`${month}-${day}`);
    }
    return dates;
};

export function getDefaultExpendAllByMenu(menu: any) {
    let arr: any = {};
    let getSubAllNodeIds = (menu: any) => {
        menu?.map((value: any, key: any) => {
            if (value.children?.length == 0) {
                // arr[value.id] = false;
                // arr.push(value.id);
            }
            else {
                arr[value.id] = false;
                getSubAllNodeIds(value.children);
            }
        });
    }
    getSubAllNodeIds(menu);
    return arr;
}